var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 10c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z",
    fill: "#5D5D74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.058 15.765 18.823 18l2.235 2.235a.387.387 0 0 1 0 .549l-.274.274a.387.387 0 0 1-.549 0L18 18.823l-2.235 2.235a.387.387 0 0 1-.549 0l-.274-.274a.387.387 0 0 1 0-.549L17.177 18l-2.235-2.235a.387.387 0 0 1 0-.549l.274-.274a.387.387 0 0 1 .549 0L18 17.177l2.235-2.235a.387.387 0 0 1 .549 0l.274.274a.393.393 0 0 1 0 .549z",
    fill: "#FFF"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.e52af524.svg";
export { ForwardRef as ReactComponent };